<template>
  <el-card class="box-card full-screen recharge-apply">
    <div ref="pageHead" class="table-page-head">
      <el-form :inline="true" :model="queryForm">
        <el-form-item :label="$t('region')">
          <el-select
            v-model="queryForm.region"
            :placeholder="$t('all')"
            filterable
            size="small"
          >
            <el-option :label="$t('all')" value=""></el-option>
            <!-- 国 -->
            <template v-for="(item, i) in countryList">
              <el-option
                v-if="item.parentId == 0"
                :key="i"
                :label="$t(item.name)"
                :value="item.id"
              ></el-option>
            </template>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('date')">
          <el-date-picker
            v-model="queryForm.date"
            type="daterange"
            range-separator="~"
            :start-placeholder="$t('startDate')"
            :end-placeholder="$t('endDate')"
            value-format="yyyy-MM-dd"
            size="small"
            unlink-panels
            :clearable="true"
            :picker-options="pickerOptions0"
            @change="changeDate"
          >
          </el-date-picker>
        </el-form-item>

        <!-- getList button-->
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="getList"
            :loading="isLoading"
            ><i class="el-icon-search"></i> {{ $t("query") }}</el-button
          >
        </el-form-item>
      </el-form>
      <el-row>
        {{ $t("Remittances whose country of origin is") }} :
        <el-button class="table-btns" type="text" size="mini">
          {{ formatRegionPays(countryName) }}
          <!-- Pass countryName as an argument -->
        </el-button>
      </el-row>
      <el-row>
        {{ $t("Total Remittance") }} :
        <el-button class="table-btns" type="text" size="mini">
          {{ globalTotalAmountRemittance }}
        </el-button>
        ---
        {{ $t("Total Remittance Fees") }} :
        <el-button class="table-btns" type="text" size="mini">
          {{ globalTotalRemittanceFees }}
        </el-button>
        ---
        {{ $t("Total of Clients") }} :
        <el-button class="table-btns" type="text" size="mini">
          {{ globalTotalCustomer }}
        </el-button>
        ---
        {{ $t("Total VAT on Remittance") }} :
        <el-button class="table-btns" type="text" size="mini">
          {{ globalTotalVATOnRemittance }}
        </el-button>
        ---
        {{ $t("Total Stamp Duty on Remittance") }} :
        <el-button class="table-btns" type="text" size="mini">
          {{ globalTotalStampDutyOnRemittance }}
        </el-button>
      </el-row>
      <el-row class="table-btns">
        <a
          @click="downloadEXCEL()"
          type="text"
          size="mini"
          :disabled="!tableData.total"
          ><i class="el-icon-download"></i> {{ $t("downloadEXCEL") }}</a
        >
      </el-row>
    </div>

    <div
      class="data-table"
      :style="{
        top: queryTableHeight,
        height: `calc(100% - ${queryTableHeight} - 70px)`,
      }"
    >
      <el-table
        :data="tableData.records"
        v-loading="isLoading"
        element-loading-background="rgba(255,255,255,0.4)"
        size="mini"
        height="100%"
      >
        <el-table-column
          type="index"
          align="center"
          fixed="left"
          min-width="50"
        ></el-table-column>

        <el-table-column
          prop="countryOrigin"
          fixed="left"
          :label="$t('Country of Origin')"
          min-width="160"
        ></el-table-column>
        <el-table-column
          prop="destinationCountry"
          fixed="left"
          :label="$t('Destination Country')"
          min-width="160"
        ></el-table-column>

        <el-table-column
          prop="totalAmountRemittance"
          :label="$t('Total Remittance')"
          min-width="200"
        >
          <template slot-scope="scope">
            <span class="franc">₣</span>
            {{
              scope.row.totalAmountRemittance
                ? scope.row.totalAmountRemittance.formatMoney(0)
                : "0"
            }}
          </template>
        </el-table-column>

        <el-table-column
          prop="totalRemittanceFees"
          :label="$t('Total Remittance Fees')"
          min-width="200"
        >
          <template slot-scope="scope">
            <span class="franc">₣</span>
            {{
              scope.row.totalRemittanceFees
                ? scope.row.totalRemittanceFees.formatMoney(0)
                : "0"
            }}
          </template>
        </el-table-column>

        <el-table-column
          prop="totalVATOnRemittance"
          :label="$t('Total VAT on Remittance')"
          min-width="200"
        >
          <template slot-scope="scope">
            <span class="franc">₣</span>
            {{
              scope.row.totalVATOnRemittance
                ? scope.row.totalVATOnRemittance.formatMoney(0)
                : "0"
            }}
          </template>
        </el-table-column>

        <el-table-column
          prop="totalStampDutyOnRemittance"
          :label="$t('Total Stamp Duty on Remittance')"
          min-width="220"
        >
          <template slot-scope="scope">
            <span class="franc">₣</span>
            {{
              scope.row.totalStampDutyOnRemittance
                ? scope.row.totalStampDutyOnRemittance.formatMoney(0)
                : "0"
            }}
          </template>
        </el-table-column>

        <el-table-column
          prop="totalCustomer"
          :label="$t('Total of Clients')"
          min-width="200"
        >
          <template slot-scope="scope">
            {{ scope.row.totalCustomer ? scope.row.totalCustomer : "0" }}
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination
      background
      layout="total,sizes,prev,pager,next,jumper"
      :total="tableData.total || 0"
      :page-sizes="[20, 30, 50, 100, 200]"
      :page-size="pageSize"
      :current-page="currentPage"
      @size-change="setPageSzie"
      @current-change="setCurrentChange"
      @prev-click="setCurrentChange"
      @next-click="setCurrentChange"
    />
  </el-card>
</template>

<script>
import transactionInfo from "@/api/transactionInfo";

import country from "@/api/country";
import business from "@/api/business";
import org from "@/api/org";
import qs from "qs";

export default {
  name: "tradingBetweenCountry",
  data() {
    return {
      pickerOptions0: {
        onPick: ({ maxDate, minDate }) => {
          this.minDate = minDate;
          this.maxDate = maxDate;
        },
        disabledDate: (time) => {
          let today = 3 * 30 * 24 * 3600 * 1000;
          if (this.minDate) {
            return (
              time.getTime() > Date.now() ||
              time > new Date(this.minDate.getTime() + today) ||
              time < new Date(this.minDate.getTime() - today)
            );
          }
          return time.getTime() > Date.now();
        },
      },
      // countryList: Array,

      isLoading: false,
      //table高度，动态设置
      queryTableHeight: String,
      tableData: {},
      //分页器默认参数
      pageSize: 20,
      currentPage: 1,
      /**查询条件 */
      queryForm: {},
      //regionC: {amount},
      businessList: [],
      /**是否是明细 */
      isDetail: true,

      orgList: [],
      countryName: "",
      globalTotalAmountRemittance: "",
      globalTotalRemittanceFees: "",
      globalTotalCustomer: "",
      globalTotalVATOnRemittance: "0",
      globalTotalStampDutyOnRemittance: "0",
    };
  },
  computed: {
    downloadUrl() {
      let _this = this;
      let param = JSON.parse(JSON.stringify(_this.queryForm));
      let params = {};
      for (let k in param) {
        if (k == "date" && param[k] && param[k].length == 2) {
          params.startTime = _this.$manba(param.date[0]).format("ymd");
          params.endTime = _this.$manba(param.date[1]).format("ymd");
        } else if (param[k]) {
          params[k] = param[k];
        }
      }
      delete params.date;
      delete params.size;
      delete params.current;

      return transactionInfo.getPageExport + "?" + qs.stringify(params);
    },
    countryList() {
      return this.$store.state.globalParameter.countryList;
    },
    loginInfo() {
      return this.$store.state.globalParameter.loginInfo;
    },
  },
  watch: {
    "queryForm.date"(newVal) {
      if (newVal && newVal.length > 0) {
        this.queryForm.startTime = this.queryForm.date[0];
        this.queryForm.endTime = this.queryForm.date[1];
      } else {
        this.queryForm.startTime = undefined;
        this.queryForm.endTime = undefined;
      }
    },
  },
  methods: {
    formatRegion(region) {
      let p1 = this.countryList.find(function(c) {
        return c.id == region;
      });
      let p2 = this.countryList.find(function(c) {
        return c.id == p1.parentId;
      });
      return p2.name + "/" + p1.name;
    },
    /**formatRegionPays (region) {
        let p1 = this.countryList.find(function (c) { return c.id == region });
        let p2 = this.countryList.find(function (c) { return c.id == p1.parentId });
        return p2.name
      },*/
    formatRegionPays(region) {
      //console.log(region);
      if (!region) return ""; // Handle case where region is null or undefined
      // Find the parent country in the countryList
      let p2 = this.countryList.find((c) => c.id == region);
      if (!p2) return ""; // Handle case where parent country is not found
      //console.log(p2.name);
      return p2.name; // Return the parent country name
    },

    downloadEXCEL() {
      if (!this.tableData.total) return;
      if (
        this.$manba(this.queryForm.date[1]).distance(this.queryForm.date[0]) >
        90
      ) {
        this.$confirm(
          this.$(
            "The end time cannot be later than 90 days after the start time"
          )
        )
          .then(() => {})
          .catch(() => {});
        return;
      }
      let download = document.createElement("a");
      download.href = this.downloadUrl;
      download.download = "";
      download.click();
    },
    getList() {
      let _this = this;

      _this.isLoading = true;
      let params = JSON.parse(JSON.stringify(_this.queryForm));
      if (params.date && params.date.length > 0) {
        params.startTime = _this.$manba(params.date[0]).format("ymd");
        params.endTime = _this.$manba(params.date[1]).format("ymd");
      } else {
        params.startTime = undefined;
        params.endTime = undefined;
      }
      delete params.date;

      transactionInfo.pageRemittanceCountries({
        param: {
          current: _this.currentPage,
          size: _this.pageSize,
          ...params,
        },
        success: function(res) {
          _this.isLoading = false;
          _this.tableData = res.data || {};

          const firstRecord = _this.tableData.records[0];

          _this.globalTotalAmountRemittance =
            firstRecord.globalTotalAmountRemittance || 0;
          _this.globalTotalRemittanceFees =
            firstRecord.globalTotalRemittanceFees || 0;
          _this.globalTotalCustomer = firstRecord.globalTotalCustomer || 0;
        },
      }),
        //this.countryName = this.tableData.records[0];

        (this.countryName = params.region);
    },
    setPageSzie(val) {
      this.pageSize = val;
      this.getList();
    },
    setCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },

    getBusiness() {
      let _this = this;
      business.getList({
        success: (res) => {
          _this.businessList = res.data.reverse();
          _this.getList();
        },
      });
    },

    getOrgList() {
      let _this = this;
      org.getOrgInfoPage({
        param: { current: 1, size: 10000 },
        success: (res) => {
          if (res.data) _this.orgList = res.data.records;
        },
      });
    },
    changeDate(e) {
      if (e === null) {
        this.minDate = "";
        this.maxDate = "";
        this.pickerBeginDateBefore = {
          disabledDate: (time) => {
            let three = 3 * 30 * 24 * 3600 * 1000;
            if (this.minDate) {
              return (
                time.getTime() > Date.now() ||
                time > new Date(this.minDate.getTime() + three) ||
                time < new Date(this.minDate.getTime() - three)
              );
            }
            return time.getTime() > Date.now();
          },
        };
      }
    },
    getCountry() {
      let _this = this;
      country.getList({
        success: (res) => {
          _this.$set(_this, "countryList", res.data);
        },
      });
    },
  },
  mounted() {
    let queryTableHeight = this.$refs.pageHead.offsetHeight + 15;
    this.queryTableHeight = queryTableHeight + "px";
    this.getBusiness();
    // this.getCountry();
    if (this.loginInfo.orgType == 1) {
      this.getOrgList();
    }
  },
};
</script>

<style></style>
